import { $ } from './lib'

document.addEventListener('DOMContentLoaded', () => {

    // Our Declare our search variables
    const $search_input = $('#SearchForm_SearchForm_Search');
    const $search_button = $('.js-show-all-results');
    const $search_results = $('.search-pane__results');
    const $search_grid = $('.js-search-results-grid');
    const base_url = `${window.location.origin}/get_search_results?search=`;
    let search_results = [];


    // Create the AbortController for the future fetch request
    let controller;


    /**
     * 
     * Debounce function
     * 
     * @param {function} callback 
     * @param {number} delay 
     * @returns 
     */
    const debounce = (callback, delay) => {
        let timeoutId = null;
        return (...args) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => callback.apply(null, args), delay);
        };
    }


    /**
     * 
     * Placeholder result template
     * 
     * @returns {string} template
     */
    const template_search_placeholder = () => {
        return /*html*/`
            <div class="search-pane__results__grid__placeholder">
                <div class="search-pane__results__grid__placeholder__image"></div>
                <div class="search-pane__results__grid__placeholder__type"><p>&nbsp;</p></div>
                <div class="search-pane__results__grid__placeholder__title"><p>&nbsp;<br>&nbsp;</p></div>
            </div>
        `;
    }


    /**
     * 
     * Search result template
     * 
     * @param {template} result 
     * @returns {string} template
     */
    const template_search_result = (result) => {
        // Only return a string if there is a result to augment
        if (result) {

            // Standard placeholder image
            let image = '/themes/mercury/dist/images/standard/generic-placeholder.png';

            if (result.image) image = result.image;

            // If the type is a resource then let's change out the placeholder image
            if (result.type === 'Resource') image = '/themes/mercury/dist/images/standard/resource-placeholder.png';

            return /*html*/`
            <a href="${result.link}" class="search-pane__results__grid__item"> 
                <div class="search-pane__results__grid__item__image">
                    <img src="${image}" width="610" height="610" loading="lazy" alt="${result.title}">
                </div>
                <div class="search-pane__results__grid__item__title"><p>${result.title}</p></div>
                <div class="search-pane__results__grid__item__type"><p>${result.sub_type}</p></div>
            </a>
            `;
        } else {
            return '';
        }
    }


    /**
     * 
     * Show the search animation by enumerating the results with three placeholder elements
     * 
     */
    const show_search_animation = () => {
        let html = '';;
        for (let i = 0; i < 2; i++) html += template_search_placeholder();
        html += template_search_placeholder();
        $search_grid.innerHTML = html;
    }


    /**
     * 
     * Show the first three search results
     * 
     */
    const update_search_results = () => {
        let html = '';;
        for (let i = 0; i < 3; i++) html += template_search_result(search_results.results[i]);
        $search_grid.innerHTML = html;
    }


    /**
     * 
     * Show the no results found message
     * 
     */
    const no_results_found = () => {
        let html = /*html*/`
        <div class="search-pane__results__grid__no-results">
            <hp5>Sorry, there are no results for that search.</p>
        </div>`;
        $search_grid.innerHTML = html;
    }


    /**
     * 
     * Redirect to the search results page showing all results
     * 
     * @returns {void} redirect to the search results page
     */
    const go_to_all_results = () => window.location = `/search-results/SearchForm/?Search=${$search_input.value}`;


    /**
     * 
     * Show the search results grid
     * 
     * @returns {void} show the search results grid
     */
    const show_predicitive_search = () => $search_results.classList.add('active');


    /**
    * 
    * Hide the search results grid
    * 
    * @returns {void} hide the search results grid
    */
    const hide_predicitive_search = () => $search_results.classList.remove('active');

    /**
     * 
     * Fetch the search results - wrapped in a debounce method to prevent excessive requests
     * 
     */
    const search = () => {

        // If there is a previous request, abort it
        if (controller) controller.abort();

        // Setup the new AbortController
        controller = new AbortController();

        // Assign our signal 
        const { signal } = controller;


        if ($search_input.value.length > 0) {

            // Log our fetch request intent
            console.time('search performed in ');

            // Fetch the newly requested results
            fetch(base_url + $search_input.value, { signal })
                .then(response => response.text())
                .then(data => {
                    console.timeEnd('search performed in ');

                    // Reassign our search results
                    search_results = JSON.parse(data);

                    // Update the search results grid with the new results or a nothing found message
                    (search_results.results.length > 0) ? update_search_results() : no_results_found();

                    // Show or hide the search all button based on results length
                    $('.search-pane__results__action').style.display = (search_results.results.length > 0) ? 'block' : 'none';
                });
        }

    };


    /**
     * 
     * Activate the search panel as soon as the user starts interacting with it
     * 
     */
    const activate_search = (event) => {

        // Show or hide the search results grid
        ($search_input.value.length) ? show_predicitive_search() : hide_predicitive_search();

        const input = String.fromCharCode(event.keyCode);

        // Test to see it the input was a letter, number or special character
        const letterNumber = /^[0-9a-zA-Z]+$/;

        // Only show the animation if a user has started typing
        if ($search_input.value.length && input.match(letterNumber)) show_search_animation();
    };


    // Event handler for the search input - this is debounced to prevent excessive requests
    $search_input.addEventListener('input', debounce(search, 200));

    // Event handler for the search input - this is instant to show action but will not search yet
    $search_input.addEventListener('keyup', activate_search);

    // Event handler for the search button - this will redirect to the search results page
    $search_button.addEventListener('click', go_to_all_results);

    // For dev purposes only - remove on live
    // document.body.classList.add('searchActive');

    // Focus on the search input
    // setTimeout(() => document.getElementById('SearchForm_SearchForm_Search').focus(), 1500);

    // on click outside of $search_results hide_predicitive_search;
    document.addEventListener('click', (e) => {
        if (!$search_results.contains(e.target)) {
            hide_predicitive_search();
            // hideSearchPane();
        }
    });

});


